module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_09-5a88d2dbaecbf7105076d0ca5441d57e.jpg";